import React, { useState } from 'react'
import TrainingTitlePage from './TitlePage'
import { useParams } from 'react-router-dom'
import HandbookCategoryList from './Handbook'
import QuestionUploadPage from './MCQExam'

function TrainingMainPage() {
  const params =useParams()
  const [activeTab,setActiveTab]=useState("learning")

  const handleActiveChange=(value)=>{
    setActiveTab(value)
  }
  return (
    <div className="p-6 bg-gray-50 rounded-lg mt-[50px]">
      <div className="flex justify-end gap-4 ">
        <button
        onClick={()=>handleActiveChange("learning")}
        // onClick={()=>handleNavigate("/manage-resource/public")}
          className={`px-4 py-2 rounded ${
            activeTab ==="learning" ? "bg-blue-500 text-white" : "bg-gray-200"
          }`}
        >
          Learning Video
        </button>
        <button
        onClick={()=>handleActiveChange("handbook")}
        // onClick={()=>handleNavigate("/manage-resource/training")}
          className={`px-4 py-2 rounded ${
           activeTab ==="handbook" ? "bg-blue-500 text-white" : "bg-gray-200"
          }`}
        >
          Learning Handbook
        </button>
        <button
        onClick={()=>handleActiveChange("exam")}
        // onClick={()=>handleNavigate("/manage-resource/training")}
          className={`px-4 py-2 rounded ${
           activeTab ==="exam" ? "bg-blue-500 text-white" : "bg-gray-200"
          }`}
        >
          FID Certification Exam
        </button>
        
      </div>
      <div>
        

        {activeTab ==="learning" ? <TrainingTitlePage />:``}
        {activeTab ==="handbook" ? <HandbookCategoryList />:``}
        {activeTab ==="exam" ? <QuestionUploadPage />:``}
      </div>
    </div>
  )
}

export default TrainingMainPage